module.exports = __webpack_public_path__ + "img/logo-white.4e3c76c1.png";